<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong>Contact</strong>
      </div>
      <ContactDialog :user="user" />
    </template>

    <Item icon="mdi-account">{{ user.name }} ({{ user.display_name }})</Item>
    <Item icon="mdi-email">{{ user.email }}</Item>
    <Item v-if="user.phone" icon="mdi-phone">{{ user.phone }}</Item>
    <Item v-else icon="mdi-key-variant">
      <span v-if="user.verified_device_count < 1" class="pr-2 red--text font-weight-bold">ACTION NEEDED</span>
      <router-link
        v-if="user.device_count < 1"
        :to="{ name: 'profile/wizard/step1'}"
      >(click to get started)</router-link>
      <router-link
        v-else
        :to="{ name: 'profile/devices'}"
      >(manage your security devices)</router-link>
    </Item>
  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import ContactDialog from '../dialogs/Contact.vue'

  export default {
    components: { ContactDialog, Section, Item },

    props: ['user'],
  }
</script>